import { orderBy } from "lodash";

import { FORMATTERS } from "app/common/benchmark/formatters";
import type { BenchmarkType } from "app/pages/benchmark-tracker/hooks/types";
import type { RankingDataSchema } from "app/pages/benchmark-tracker/types/api.types";
import type { IWebsitesFavicons } from "app/services/sitesService/types";

import type { MetricFormat } from "app/common/benchmark/types";

import type { Axis, AxisPositions, Positions } from "app/components/RankingAxis/types";

export const getAxisLineData = (
    metricData: RankingDataSchema,
    selectedBenchmark: BenchmarkType,
    domainImages: IWebsitesFavicons = {},
    domains: string[] = [],
): Axis[] => {
    const competitorsData = metricData.competitorsData;
    const metaData: Axis[] = [];

    if (!competitorsData) {
        return [];
    }

    const competitorsDataKeys = Object.keys(competitorsData);
    const primaryDomain = selectedBenchmark?.primaryDomains[0];

    const hasWebsites = !!domains.length;

    if (hasWebsites) {
        domains.forEach((item) => {
            const isPrimaryEntity = item === primaryDomain;

            if (competitorsDataKeys.includes(item) || isPrimaryEntity) {
                metaData.push({
                    name: item,
                    image: domainImages[item] ?? "",
                    absoluteValue: isPrimaryEntity
                        ? (metricData?.primaryData?.absoluteValue ?? 0)
                        : (competitorsData[item]?.absoluteValue ?? 0),
                    isSegment: false,
                    isPrimaryEntity,
                    rank: isPrimaryEntity ? (metricData?.primaryData?.rank ?? 0) : (competitorsData[item]?.rank ?? 0),
                    rankChange: isPrimaryEntity
                        ? (metricData?.primaryData?.rankChange ?? 0)
                        : (competitorsData[item]?.rankChange ?? 0),
                });
            }
        });
    }

    return orderBy(metaData, "rank", "asc").reverse();
};

export const getAxisPositions = (data: Axis[], format: MetricFormat): AxisPositions | undefined => {
    if (data?.length) {
        const countsNumbers = data.map(({ absoluteValue }) => absoluteValue);
        const min = Math.min(...countsNumbers);
        const max = Math.max(...countsNumbers);
        const positions: Positions[] = [];

        data.forEach((axis) => {
            positions.push({
                ...axis,
                position: ((axis.absoluteValue - min) / (max - min)) * 100,
            });
        });

        const formatFn = FORMATTERS[format];
        return {
            minDot: {
                count: formatFn(min),
                position: 0,
            },
            maxDot: {
                count: formatFn(max),
                position: 100,
            },
            positions,
        };
    }
};
